/**
 * ヤギプライム決済完了ポップアップ。
 * YagiprimePaymentService から open、App 配下の PrimeCompletePopup が購読。
 */
import localforage from 'localforage'
import { defineStore } from 'pinia'
import { ref } from 'vue'
import { emitHideAiMyprDialog } from '@/plugins/emitter'
import { useSkillDiagnosisPopupStore } from './skillDiagnosisPopup'

export const usePrimeCompletePopupStore = defineStore(
  'primeCompletePopup',
  () => {
    const visible = ref(false)
    const hasResumeData = ref(false)
    let onClosed: (() => void) | null = null

    async function open(callback?: (() => void) | null) {
      onClosed = typeof callback === 'function' ? callback : null
      emitHideAiMyprDialog()
      try {
        const basicData = await localforage.getItem('basicData')
        hasResumeData.value = !!basicData
      } catch {
        hasResumeData.value = false
      }
      visible.value = true
    }

    function runOnClosed() {
      const cb = onClosed
      onClosed = null
      if (typeof cb === 'function') {
        try {
          cb()
        } catch (error) {
          console.error('[PrimeCompletePopup] コールバック実行エラー:', error)
        }
      }
    }

    function close() {
      if (!visible.value) return
      visible.value = false
      runOnClosed()
    }

    function setVisible(value: boolean) {
      if (visible.value === value) return
      visible.value = value
      if (!value) runOnClosed()
    }

    function goToDiagnosis() {
      onClosed = null
      visible.value = false
      useSkillDiagnosisPopupStore().open()
    }

    return {
      visible,
      hasResumeData,
      open,
      close,
      setVisible,
      goToDiagnosis
    }
  }
)
